import { render, staticRenderFns } from "./TosListVuetify.vue?vue&type=template&id=5a9f4240&scoped=true&"
import script from "./TosListVuetify.vue?vue&type=script&lang=js&"
export * from "./TosListVuetify.vue?vue&type=script&lang=js&"
import style0 from "./TosListVuetify.vue?vue&type=style&index=0&id=5a9f4240&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9f4240",
  null
  
)

export default component.exports